const MONITOR = 'monitor';
const ENTREGA = 'entrega';
const PREFIJOS = 'prefijos';
const ESTACIONES = 'estaciones';
const TICKETS = 'tickets';
const LISTAS = 'listas_precios';
const BALANZAS = 'balanzas';
const ENTRADAS = 'entradas';
const PEDIDOS = 'pedidos';
const INVENTARIO = 'inventario';
const FACTURACION = 'facturacion';
const WHATSAPP = 'whatsapp'
const GENERAL = 'general'
const REPORTES = 'reportes'

export default {
  MONITOR,
  ENTREGA,
  PREFIJOS,
  ESTACIONES,
  TICKETS,
  LISTAS,
  BALANZAS,
  ENTRADAS,
  PEDIDOS,
  FACTURACION,
  INVENTARIO,
  WHATSAPP,
  GENERAL,
  REPORTES
}
